import { render, staticRenderFns } from "./account-balance-query.vue?vue&type=template&id=9e568c74&scoped=true&lang=pug"
import script from "./account-balance-query.vue?vue&type=script&lang=js"
export * from "./account-balance-query.vue?vue&type=script&lang=js"
import style0 from "./account-balance-query.vue?vue&type=style&index=0&id=9e568c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e568c74",
  null
  
)

export default component.exports